import { themeGet, createGlobalStyle } from '@style'

const GlobalStyles = createGlobalStyle`
  *,
  *::after,
  *::before {
    margin: 0;
    padding: 0;
  }

  a {
    color: ${themeGet('colors.grey.700')};
    text-decoration: none;
    cursor: pointer;

    &:hover,
    &:focus {
      text-decoration: underline;
    }
  }
  
  body {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    min-height: 100%;
    font-family: "Nunito Sans";
  }

  html {
    height: 100%;
  }
`

export default GlobalStyles
